import styled from '@emotion/styled';
import { colors } from '@atlaskit/theme';

export const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  justify-content: center;
`;

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  svg {
    margin-left: 4px;
    color: ${colors.G400};
  }
`;
